export default {
    computed: {
      formattedZipcode: {
        get() {
          return this.form.zipcode;
        },
        set(value) {
            // The regular expression /\D/g matches any non-digit character globally (g modifier),
            // effectively removing all non-digit characters from the input value.
          this.form.zipcode = value.replace(/\D/g, '');
        }
      }
    }
  };